<template>
  <v-card class="mx-4">
    <!-- <v-layout class="buttons" justify-end row align-center>
        <v-btn
          class="TierButton mb-1 mr-0 ml-1"
          @click="openCreateUserForm()"
        >
          + New User
        </v-btn>
    </v-layout>-->

    <!-- DASHBOARD TABLE -->
    <v-data-table
      :headers="headers"
      :items="dashboards"
      :item-key="dashboards.index"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      :loading="loading"
      :total-items="totalRecords"
      @update:pagination="paginationUpdated"
      hide-details
      class="striped-table no-pagination-btn"
    >
      <template slot="items" slot-scope="props">
        <tr
          :key="props.index"
          :class="categoryClass(props.item.CategoryName)"
          :style="{
                        backgroundColor: (props.item.DBID == selectedRow ? '#C6EFCE' : '' ), 
                        color: (props.item.DBID == selectedRow ? '#00612e' : 'black' ),
                      }"
        >
          <td class="text-xs-left px-0">
            <text-highlight :queries="searchHighlight">{{ props.item["CategoryName"] | uppercase }}</text-highlight>
          </td>
          <td class="text-xs-left px-0">
            <text-highlight :queries="searchHighlight">{{ props.item["DashboardID"] }}</text-highlight>
          </td>
          <td class="text-xs-left px-0">
            <text-highlight :queries="searchHighlight">{{ props.item["Name"] }}</text-highlight>
          </td>
          <td class="text-xs-left px-0">
            <text-highlight :queries="searchHighlight">{{ props.item["SubmitBy"] }}</text-highlight>
          </td>
           <td class="text-xs-left px-0">
            <text-highlight :queries="searchHighlight">{{ props.item["Users"] }}</text-highlight>
          </td>
          <td
            class="text-xs-left px-0"
            :class="[{'green--text':props.item.IsEnabled==true},{'red--text':props.item.IsEnabled==false} ]"
          >{{ props.item["IsEnabled"] == true?"ENABLED": "DISABLED" }}</td>

          <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
            <a
              class="ml-0 align-center"
              style="text-decoration: none"
              @click="openEditDashboard(props.item)"
            >EDIT</a>
          </td>
        </tr>
      </template>
      <v-alert slot="no-results" :value="true" color="red lighten-3" icon="fa-exclamation-triangle">
        Your
        search for "{{ search }}" found no results.
      </v-alert>
      <template slot="no-data">
        <v-layout row justify-start align-center>
          <v-flex xs2 style="font-size: 14px;">
            <span v-show="hasFilter">No records found for the applied filters</span>
          </v-flex>
          <v-flex xs8>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
    </v-data-table>
    <!-- END USERS TABLE -->
    <editDashboard
      ref="editDashboard"
      @parentRefresh="paginationUpdated"
      @parentInitSelectedRow="initSelectedRow"
      id="editDashboard"
      @parentScroll="$vuetify.goTo('#editDashboard')"
    ></editDashboard>
  </v-card>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import Bus from "../../bus";
import zigZag from "../../components/ZigZag.vue";
import * as helper from "../../helpers/global.js";
import createUser from "./CreateUser.vue";
import moment from "moment";
import editDashboard from "./EditDashboardsManagement.vue";
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "DashboardsManagement",

  components: {
    VPage,
    zigZag,
    createUser,
    editDashboard,
    DataTablePagination
  },

  data: () => ({
    dashboards: [],
    loading: false,
    totalRecords: 0,
    filters: {},
    search: "",

    selectedRow: null,
    searchHighlight: "",

    // Selected by default
    pagination: {
      rowsPerPage: 30,
      descending: false,
      sortBy: "DBID",
      page: 1,
      totalItems: 0
    },

    rowsPerPageItems: [
      5,
      10,
      30,
      {
        text: "$vuetify.dataIterator.rowsPerPageAll",
        value: -1
      }
    ],

    headers: [
      {
        text: "Category",
        value: "CategoryName",
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Dashboard ID",
        value: "DashboardID",
        // sortable: false,
        width: "5%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-0"
      },
      {
        text: "Name",
        value: "Name",
        // sortable: false,
        width: "28%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Owner",
        value: "SubmitBy",
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Users",
        value: "Users",
        width: "15%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Status",
        value: "IsEnabled",
        width: "23%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "21%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ]
  }),
  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },
  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },
  mounted() {},
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    },
    uppercase: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  methods: {
    async initialize() {
      this.filters = {};
      this.selectedRow = null;

      this.paginationUpdated();
    },
    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/Dashboards/GetPagedAllDashboardList/",
          {
            postData: {
              pagination: this.pagination,
              filtersChanged: this.filtersChanged,
              filters: this.filters,
              search: this.search,
              totalRecords: this.totalRecords
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.dashboards = response.data.dashboards;
          this.totalRecords = response.data.totalRecords;
        });
      this.loading = false;
      this.filtersChanged = false;
    },
    categoryClass(item) {
      if (item) {
        var categoryClass;
        categoryClass = item
          .split(" ")
          .join("")
          .replace("/", "");
        return categoryClass;
      }
    },
    async openEditDashboard(item) {
      let index = this.dashboards.indexOf(item);
      if (index > -1) {
        this.selectedRow = this.dashboards[index].DBID;
      }
      // await this.$refs.createUser.close();
      this.$refs.editDashboard.openEdit(item);
    },
    initSelectedRow() {
      this.selectedRow = null;
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
table.v-table tbody tr:hover {
  background-color: #eeeeee !important;
}

.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
/deep/ tr:hover {
  background-color: #eeeeee !important;
}
/deep/ table.v-table tbody tr.AccountsReceivables:nth-child(odd) {
  background-color: #ecf0f8;
  /* background-color:#d9e1f2; */
}
/deep/ table.v-table tbody tr.BilledRevenue:nth-child(odd) {
  background-color: #fdf1ea;
  /* background-color:#fce4d6; */
}
/deep/table.v-table tbody tr.BusinessOperations:nth-child(odd) {
  background-color: #f6f6f6;
  /* background-color:#ededed; */
}
/deep/table.v-table tbody tr.Sales:nth-child(odd) {
  background-color: #fff8e5;
  /* background-color:#fff2cc; */
}
/deep/table.v-table tbody tr.ServiceOperations:nth-child(odd) {
  background-color: #eef5fb;
  /* background-color:#ddebf7; */
}
/deep/table.v-table tbody tr.PROVISIONING:nth-child(odd) {
  background-color: #f0f7ec;
  /* background-color:#e2efda; */
}
/deep/table.v-table tbody tr.REGULATORY:nth-child(odd) {
  background-color: #ffe3e6;
  /* background-color:#ffc7ce; */
}
/deep/table.v-table tbody tr.SALESANDMARKETING:nth-child(odd) {
  background-color: #fff5cd;
  /*  background-color:#ffeb9c; */
}
/deep/table.v-table tbody tr.SOFTALARMS:nth-child(odd) {
  background-color: #d9e2f3;
  /* background-color:#B4C6E7; */
}
/deep/table.v-table tbody tr.TICKETTROUBLE:nth-child(odd) {
  background-color: #fbe5d6;
  /* background-color:#F8CBAD; */
}
/deep/table.v-table tbody tr.USERDEFINED:nth-child(odd) {
  background-color: #ededed;
  /* background-color:#dbdbdb; */
}
/deep/ table.v-table tbody tr.AccountsReceivables:nth-child(even) {
  background-color: #ecf0f885;
  /* background-color:#d9e1f2; */
}
/deep/ table.v-table tbody tr.BilledRevenue:nth-child(even) {
  background-color: #fdf1ea81;
  /* background-color:#fce4d6; */
}
/deep/table.v-table tbody tr.BusinessOperations:nth-child(even) {
  background-color: #f6f6f679;
  /* background-color:#ededed; */
}
/deep/table.v-table tbody tr.Sales:nth-child(even) {
  background-color: #fff8e581;
  /* background-color:#fff2cc; */
}
/deep/table.v-table tbody tr.ServiceOperations:nth-child(even) {
  background-color: #eef5fb7e;
  /* background-color:#ddebf7; */
}
/deep/table.v-table tbody tr.PROVISIONING:nth-child(even) {
  background-color: #f0f7ec81;
  /* background-color:#e2efda; */
}
/deep/table.v-table tbody tr.REGULATORY:nth-child(even) {
  background-color: #ffe3e67e;
  /* background-color:#ffc7ce; */
}
/deep/table.v-table tbody tr.SALESANDMARKETING:nth-child(even) {
  background-color: #fff5cd81;
  /*  background-color:#ffeb9c; */
}
/deep/table.v-table tbody tr.SOFTALARMS:nth-child(even) {
  background-color: #d9e2f37e;
  /* background-color:#B4C6E7; */
}
/deep/table.v-table tbody tr.TICKETTROUBLE:nth-child(even) {
  background-color: #fbe5d680;
  /* background-color:#F8CBAD; */
}
/deep/table.v-table tbody tr.USERDEFINED:nth-child(even) {
  background-color: #ededed80;
  /* background-color:#dbdbdb; */
}
</style>
